import { createSelector } from 'reselect';

const Search = 'search';

const selectUnpaidFees = (state) => state.get(Search).get('unpaidFees');

const getUnpaidFees = createSelector(selectUnpaidFees, (data) => data);

const selectIsLoading = (state) => state.get(Search).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

const selectAddressSuggestions = (state) => state.get(Search).get('addressSuggestions');

const getAddressSuggestions = createSelector(selectAddressSuggestions, (data) => data);

const selectActionResponse = (state) => state.get(Search).get('actionResponse');
const getSearchActionResponse = createSelector(selectActionResponse, (data) => data);

export { getUnpaidFees, getLoadingStatus, getAddressSuggestions, getSearchActionResponse };
